import { generatePath } from '@ps/web-core-utils';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import type { RouteComponentProps } from 'react-router';
import { Redirect, useLocation } from 'react-router-dom';
import { qs } from 'url-parse';

import { select } from '@swf/core/store';
import { launchGame } from '@swf/core/utils/casino';

export interface CasinoLaunchPayload {
  code: string;
  raceId: string;
  fsb: string;
}

const CasinoGameLaunch: React.FC<RouteComponentProps<{ id: string; type: 'game' | 'race' }>> = ({
  match
}) => {
  const location = useLocation();
  const { id } = match.params;

  const aliases = useSelector(select.cms.getAliases);

  useEffect(() => {
    const { code, raceId, fsb } = qs.parse(location.search) as CasinoLaunchPayload;
    const race = match.params.type === 'race';
    launchGame({ id, code, raceId, race, fsb, externalLaunch: true });
  }, [id, location.search, match.params.type]);

  return <Redirect to={aliases.home ? generatePath(aliases.home, {}) : '/casino/'} />;
};

export default CasinoGameLaunch;
